export default "__VITE_ASSET__476d232e__"